import { useLayoutEffect, useMemo } from 'react';
import { createPortal } from 'react-dom';
import { appendPortalContainer, createContainer, removePortalContainer, removePortalParentContainerIfNoMorePortals } from '../utils/portal-dom-utils';
export default function InternalPortal(props) {
  var zIndex = props.zIndex,
      children = props.children;
  var container = useMemo(function () {
    return createContainer(zIndex);
  }, [zIndex]);
  useLayoutEffect(function () {
    appendPortalContainer(container);
    return function () {
      removePortalContainer(container);
      removePortalParentContainerIfNoMorePortals();
    };
  }, [container]);
  return (
    /*#__PURE__*/
    createPortal(children, container)
  );
}